/* PSE Product Page interactivity:
   gallery thumbs, qty stepper, live ATC total, variant select → price/sku,
   sticky rail/mobile add-to-cart proxy, delivery date window. */
(function () {
  const root = document.querySelector('product-info');
  if (!root) return;

  const form = document.getElementById('PseProductForm');
  const qtyInput = root.querySelector('[data-pse-qty-input]');
  const priceEl = root.querySelector('[data-pse-price]');
  const totalEl = root.querySelector('[data-pse-total]');
  const skuEl = root.querySelector('[data-pse-sku]');
  const compareEl = root.querySelector('[data-pse-compare]');
  const variantIdInput = root.querySelector('[data-pse-variant-id]');
  const variantsJson = root.querySelector('[data-pse-variants]');
  const variants = variantsJson ? JSON.parse(variantsJson.textContent) : null;

  let currentPrice = null;
  const money = (cents) => {
    const formatted = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (window.PseMoneyPrefix || '$') + formatted;
  };
  if (priceEl) {
    const m = priceEl.textContent.match(/[\d,.]+/);
    if (m) currentPrice = Math.round(parseFloat(m[0].replace(/,/g, '')) * 100);
  }

  // Gallery thumbs
  const mainImg = root.querySelector('[id^="PseMainImage"]');
  root.querySelectorAll('[data-pse-thumb]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (mainImg) mainImg.src = btn.dataset.src;
      root.querySelectorAll('[data-pse-thumb]').forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  // Qty stepper + live total
  const updateTotal = () => {
    if (!totalEl || currentPrice == null) return;
    const qty = Math.max(1, parseInt(qtyInput?.value, 10) || 1);
    totalEl.textContent = money(currentPrice * qty);
  };
  root.querySelectorAll('[data-pse-qty]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const delta = parseInt(btn.dataset.pseQty, 10);
      const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
      qtyInput.value = next;
      updateTotal();
    });
  });
  qtyInput?.addEventListener('change', updateTotal);

  // Variant selection → find matching variant, update id/price/sku
  const selects = root.querySelectorAll('[data-pse-option]');
  if (selects.length && variants) {
    const onVariantChange = () => {
      const chosen = Array.from(selects).map((s) => s.value);
      const match = variants.find((v) =>
        chosen.every((val, i) => v['option' + (i + 1)] === val)
      );
      if (!match) return;
      variantIdInput.value = match.id;
      currentPrice = match.price;
      if (priceEl) priceEl.textContent = money(match.price);
      if (skuEl && match.sku) skuEl.textContent = match.sku;
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      document.querySelectorAll('[data-pse-rail-price], [data-pse-sticky-price]').forEach((el) => {
        el.textContent = money(match.price);
      });
      const atc = form?.querySelector('[name="add"]');
      if (atc) atc.disabled = !match.available;
      updateTotal();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    };
    selects.forEach((s) => s.addEventListener('change', onVariantChange));
  }

  // Rail / sticky-bar ATC proxies submit the main form
  document.querySelectorAll('[data-pse-rail-add]').forEach((btn) => {
    btn.addEventListener('click', () => {
      form?.querySelector('[name="add"]')?.click();
    });
  });

  // Delivery window: today + 2..5 business days
  const windowEl = root.querySelector('[data-pse-delivery-window]');
  if (windowEl) {
    const addBiz = (from, days) => {
      const d = new Date(from);
      let left = days;
      while (left > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) left--;
      }
      return d;
    };
    const fmt = (d) => d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    const now = new Date();
    windowEl.textContent = fmt(addBiz(now, 2)) + ' to ' + fmt(addBiz(now, 5));
  }
})();
